import { useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import useResponses from '../../../hooks/useResponses';
import { toSubjects } from '../../../utils/creator';
import { toIcon } from '../../../utils/roundUtils';
import { zIndexes } from '../../../utils/zIndexes';
import { IconWrapper } from '../../_atoms/IconWrapper';
import { Slide } from '../../SlideComponents/slide.types';

const ResponseSummary = ({
  currentSlide,
  gameId,
  tenantId,
}: {
  currentSlide: Slide;
  gameId: string;
  tenantId: string;
}) => {
  const { count } = useResponses(gameId, currentSlide.id, true, tenantId);
  const { t } = useTranslate();
  return (
    <ResponsecounterWidgetContainerCenter style={{ height: 'auto' }}>
      <div style={{ width: '100%' }}>
        <IconWrapper style={{ cursor: 'default' }} height={`60px`} width={`60px`}>
          {toIcon(currentSlide.type as string).icon}
        </IconWrapper>
      </div>
      <div>
        <strong>{count} </strong> {toSubjects(t, currentSlide.type, count !== 1)}
      </div>
    </ResponsecounterWidgetContainerCenter>
  );
};

const ResponsecounterWidgetContainerCenter = styled.div`
  color: ${theme.colors.white};
  font-size: 30px;
  padding: 20px;
  svg {
    color: ${theme.colors.white};
  }
  font-weight: 600;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  right: 50%;
  border-radius: 10px;
  background-color: ${theme.colors.translucentLightBlack};
  position: absolute;
  display: grid;
  grid-template-columns: 1fr;
  top: 50%;
  transform: translateX(50%);
  z-index: ${zIndexes('RESPONSECOUNTER_WIDGET_CONTAINER_CENTER')};
`;

export default ResponseSummary;
